import { useEffect } from 'react';
import { IconButton } from '@livechat/ui-kit';
import { isMobile, isIOS } from 'react-device-detect';
import { PropTypes } from 'prop-types';
import { CommonStyles } from './balance-cancellation/CommonStyles';
import { bankDomains } from './utils/CommonData';
import { API_CONFIG } from '../../config/apiconfig';

const useCommonStyles = CommonStyles();

const Minimized = ({
  maximize,
  btnIntentTrigger,
  handlerIntentTrigger,
  getAccessToken,
  token,
  baseURL,
}) => {
  const CommoncssStyles = useCommonStyles();
  useEffect(() => {
    if (btnIntentTrigger !== '') {
      const timerId = setTimeout(async () => {
        if ('parentIFrame' in window) {
          for (const target of bankDomains) {
            window.parent.postMessage('disable loader', target);
          }
        }
        try {
          await chatIconClicked();
        } catch (err) {
          // console.error('Unable to open chatbot for intent', err);
        } finally {
          handlerIntentTrigger();
        }
      }, 1000);
      return () => clearTimeout(timerId);
    }
    return undefined;
  }, [btnIntentTrigger]);
  const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet';
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return 'mobile';
    }
    return 'desktop';
  };
  const chatIconClicked = async () => {
    if (typeof window !== 'undefined') {
      if (window.parentIFrame) {
        window.parentIFrame.getPageInfo((obj) => {
          const winHeight = (obj.windowHeight * 99) / 100;
          if (getDeviceType() === 'mobile') {
            window.parentIFrame.size(winHeight, obj.windowWidth);
          } else {
            window.parentIFrame.size(winHeight, 470);
          }
          if (!isMobile && !isIOS) {
            document
              .getElementsByClassName('main-wrapper')[0]
              ?.setAttribute('style', 'width: 95vw !important; height: 94vh !important;');
            document.getElementsByClassName('main-wrapper')[0].style.width = '95vw !important';
            document
              .getElementsByClassName('main-container')[0]
              ?.setAttribute('style', 'width: 95vw !important; height: 94vh !important;');
            document.getElementsByClassName('main-container')[0].style.width = '95vw !important';
            document.getElementsByClassName('main-wrapper')[0].style.height = '95vh !important';
            document.getElementsByClassName('main-container')[0].style.height = '95vh !important';
          }
        });
      }
    }
    await getAccessToken();

    maximize();
  };
  return (
    <IconButton
      onClick={chatIconClicked}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: '0',
      }}
      className={CommoncssStyles.minimized}
      data-testid="chatIcon_testid"
    >
      {!btnIntentTrigger && baseURL && Object.keys(baseURL).length > 0 && (
        <img
          src={`${baseURL?.IMAGE_BASE_URL}${API_CONFIG.CHATBOT_ICON}`}
          alt="chatbot"
          tabIndex="0"
          width="80"
          height="60"
        />
      )}
    </IconButton>
  );
};
export default Minimized;

Minimized.propTypes = {
  btnIntentTrigger: PropTypes.string,
  maximize: PropTypes.func,
  handlerIntentTrigger: PropTypes.func,
  getAccessToken: PropTypes.func,
  token: PropTypes.string,
  baseURL: PropTypes.object,
};
